<template>
  <div>
    <v-divider></v-divider>
    <template>
      <v-simple-table dense height="400px">
        <template v-slot:default>
          <thead>
            <tr>
              <th style="width: 15%;">ID</th>
              <th style="width: 30%;">Name</th>
              <th style="width: 25%;">Beginn</th>
              <th style="width: 20%;">Teilgenommen</th>
              <!--<th style="width: 5%;"></th>-->
              <th style="width: 5%;"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="matching in matchingList" :key="matching.id">
              <td>{{ matching.id }}</td>
              <td>{{ matching.title }}</td>
              <td>{{ matching.start }}</td>
              <td>{{ matching.participant }} / {{ matching.total }}</td>
              <!--<td>
                <v-btn
                  text
                  small
                  color="primary"
                  @click="startMatching(matching.id)"
                  >Zuordnen</v-btn
                >
              </td>-->
              <td>
                <v-btn
                  text
                  small
                  color="secondary"
                  @click="exportMatching(matching)"
                  >Exportieren</v-btn
                >
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "MatchingAdminTable",
  props: ["matchings"],
  setup(props, { root }) {
    const matchingList = props.matchings;

    // https://stackoverflow.com/a/58872399
    const downloadStringAsFile = (filename, text) => {
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }

    const startMatching = (id) => {
      root.$axios.get(`matching/${id}/start`).then((_) => alert("finished"));
    };
    const exportMatching = (matching) => {
      root.$axios.get(`matching/${matching.id}/export`).then((result) => {
        if (result.status == 200) {
          console.log(result.data)
          downloadStringAsFile('matching_' + matching.title.replaceAll(' ', '_').replaceAll('/', '-') + '.json',
            JSON.stringify(result.data))
        } else {
          console.log(result)
        }
      });
    }
    return {
      matchingList,
      exportMatching,
      startMatching,
    };
  },
});
</script>

<style>

button {
  background-color: transparent !important;
}
</style>
